import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import classNames from 'classnames/bind';
import { func } from 'prop-types';
import { CloseSmallLinear } from "../../icons";
import styles from '../Select.css';
import { innerPropsPropTypes, selectPropsPropTypes } from '../shapes';
var cx = classNames.bind(styles);
export var MultiValueRemove = function MultiValueRemove(_ref) {
  var innerRef = _ref.innerRef,
      innerProps = _ref.innerProps,
      _ref$selectProps = _ref.selectProps,
      isMobile = _ref$selectProps.isMobile,
      classes = _ref$selectProps.classes;

  var handleClick = function handleClick(e) {
    e.stopPropagation();

    if (!isMobile) {
      innerProps.onClick();
    }
  };

  var handleTouch = function handleTouch(e) {
    e.stopPropagation();
    innerProps.onClick();
  };

  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button"
  }, isMobile ? {
    onClick: handleClick,
    onTouchStart: handleTouch
  } : _objectSpread(_objectSpread({}, innerProps), {}, {
    onClick: handleClick
  }), {
    ref: innerRef,
    className: cx('MultiValueRemove', classes.multiValueRemove)
  }), /*#__PURE__*/React.createElement(CloseSmallLinear, null));
};
MultiValueRemove.propTypes = process.env.NODE_ENV !== "production" ? {
  innerRef: func,
  innerProps: innerPropsPropTypes,
  selectProps: selectPropsPropTypes
} : {};